import { theme } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

const container = { flexGrow: 1 }
const center = { textAlign: 'center' }
const error = {
  ...center,
  marginTop: '220px',
  fontFamily: themeVars.walsheim,
  fontSize: '144px',
  fontWeight: themeVars.walsheimWeightBold,
  color: theme.colors.borderGray,
}
const tagLine1 = {
  ...center,
  fontFamily: themeVars.walsheim,
  fontSize: theme.fontSizeNames.huge,
  fontWeight: themeVars.walsheimWeightBold,
  color: theme.colors.black,
  padding: '2px 0 4px 0',
}
const tagLine2 = {
  ...center,
  fontFamily: themeVars.graphik,
  fontWeight: themeVars.graphikWeightRegular,
  fontSize: theme.fontSizeNames.large,
  color: theme.colors.black,
  padding: '2px 0 3px 0',
}

export default { container, center, error, tagLine1, tagLine2 }
